import { createFileRoute } from '@tanstack/react-router';
import { AddMemberPage } from '../components/pages/BusinessPage/AddMemberPage';

export const Route = createFileRoute('/account/business_/add-member')({
  component: AddMemberPage,
});
